var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.192,
    height: 41,
    viewBox: "0 0 45.192 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-home",
    "data-name": "Icon metro-home",
    d: "M47.762,27.552l-22.6-17.539L2.571,27.552V20.4l22.6-17.539L47.762,20.4Zm-5.649-.637V43.861h-11.3V26.914h-11.3V43.861H8.22V26.914L25.167,14.2,38.62,24.294Z",
    transform: "translate(-2.571 -2.861)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.aac3b4154977911ca579a6fa4045a9f9.svg";
export { ForwardRef as ReactComponent };